import {Typography} from 'antd';
import {AnchorLink, PropertyList} from 'components';
import {StatusTag} from 'components/StatusTag';
import humanize from 'humanize-string';
import {colors} from 'lib/colors';
import React from 'react';
import {PibisiStatusTag} from 'routes/Account/Pibisi/PibisiStatusTag';
import {config} from 'stage.config';
import {PibisiAlert} from './types';

type Props = {
  alert: PibisiAlert | null;
};

const {Text} = Typography;

export const Alert: React.FC<Props> = ({alert}) => {
  if (!alert) return null;
  return (
    <PropertyList
      omitEmpty
      properties={[
        {
          label: 'Alert ID',
          value: (
            <AnchorLink
              href={`https://pibisi.com/es/a/${config.pibisiAccountId}/alerts/${alert.id}`}
              target="_blank">
              {alert.id}
            </AnchorLink>
          )
        },
        {
          label: 'Legal type',
          value: alert.legalType
        },
        {
          label: 'Legal name',
          value: alert.legalName
        },
        {
          label: 'Alert Type',
          value: <StatusTag color={colors.error}>{humanize(alert.type || '')}</StatusTag>
        },
        {
          label: 'Alert Status',
          value: <PibisiStatusTag status={alert.status} />
        },
        {
          label: 'Note',
          value: alert.note
        }
      ]}
    />
  );
};
